<template>
  <div class="quick-link-container">
    <a
      :class="['item', link.name]"
      v-for="(link, index) in cmsConfig.quickLink || []"
      :key="index"
      :href="link.href"
      @click="itemClickHandler(link)">
      <template v-if="link.callback === 'popup'">
        <Popover overlayClassName='kefu-popover' trigger='click' placement="leftTop">
          <template class='kefu-popover-content' slot="content">
            <p class='kefu-popover-title'>快速咨询</p>
            <ul class="online-quick">
              <li>
                <a @click="itemClickHandler({link: '//btalk.haiziwang.com/3', callback: 'windowOpen', extra: '750*648'})">客服在线沟通</a>
              </li>
            </ul>
            <p class='kefu-popover-title'>在线客服</p>
            <ul class='kefu-qq-list'>
              <li v-for="(item, index) in qqList" :key="index">
                <a class='kefu-qq-item' :href="getQQLink(item)" target="_blank">
                  <p class='kefu-qq-item-title'>财务客服{{index + 1}}</p>
                  <img v-if="item.image" :src="item.image">
                  <img v-else src="https://hzwimspic-1251601690.picsh.myqcloud.com/182c11c0-384d-11ea-b032-77fa8e93e30e_size_77x22">
                </a>
              </li>
              <li>
                <a class='kefu-qq-item'/>
                <p class='kefu-qq-item-title'>财务客服QQ: &nbsp; &nbsp;758536013 </p>

              </li>
            </ul>
            <p class='kefu-popover-title'>联系方式</p>
            <div class='kefu-contact' v-for="(item) in cmsConfig.kefu.contact" :key="item._id">
              <p>{{item.title}}</p>
              <p>{{item.phone}}</p>
            </div>
            <p class='kefu-popover-title'>工作时间</p>
            <div class='kefu-worktime' v-for="(item) in cmsConfig.kefu.worktime" :key="item._id">
              <p>{{item}}</p>
            </div>
          </template>
          <img :src="link.icon" alt="">
        </Popover>
      </template>
      <template v-else>
        <img :src="link.icon" alt="">
      </template>
    </a>
  </div>
</template>

<script>
  import { Popover } from 'ant-design-vue'
  export default {
    name: "quick-link",
    data() {
      return {
        visible: false,
        qqList: []
      }
    },
    props: {
      cmsConfig: {
        type: Object,
        default: () => {}
      }
    },
    async created() {
      const json = await this.$store.dispatch('brandHome/getCategoryQQ')
      this.qqList = json.concat((this.cmsConfig.kefu || {}).qq || [])
    },
    methods: {
      itemClickHandler (link) {
        if(link.callback === 'windowOpen'){
          let extra = link.extra && link.extra.split('*')
          let width = 750, height = 648
          if(Array.isArray(extra) && extra.length === 0){
            width = extra[0]
            height = extra[1]
          }
          let left = (window.screen.availWidth - width) / 2
          let top = 60
          window.open(link.link, '_blank', `width=${width},height=${height},left=${left},top=${top}`)
          return
        }
        if (link.link) {
          this.$emit('itemClick', link.link)
        }
        if (link.callback) {
          this[link.callback] && this[link.callback]()
        }
      },
      getQQLink(item) {
        if (item.link) {
          return item.link
        } else {
          return `//wpa.qq.com/msgrd?v=3&uin=${item.qq_number || item.title}&site=qq&menu=yes`
        }
      },
      cancelHandler () {
        this.visible = false
      }
    },
    components: {
      Popover
    }
  }
</script>

<style lang="scss">
.kefu-popover{
  width: 220px;
  .kefu-popover-title{
    font-size: 14px;
    color: $title-color-333;
    padding-bottom: 10px;
  }
  .kefu-qq-list{
    .kefu-qq-item{
      display: flex;
      align-items: center;
      margin-bottom: 10px;
    }
    .kefu-qq-item-title{
      font-size: 13px;
      color: $color-666;
      padding-right: 10px;
    }
  }
  .kefu-contact, .kefu-worktime{
    font-size: 13px;
    color: $color-666;
    margin-bottom: 10px;

    p{
      margin-bottom: 10px;
    }
  }
  .online-quick {
    padding-bottom: 10px;
    border-bottom: 1px solid #f6f6f6;
    margin-bottom: 10px;
  }
}
</style>
<style lang="scss" scoped>
.quick-link-container {
  position: fixed;
  bottom: 19%;
  right: 30px;
  /* 低于遮罩层 */
  z-index: 800;
  .item {
    text-align: center;
    display: block;
    margin-bottom: 12px;
    border-radius: 8px;
    img {
      width: 60px;
      height: 60px;
    }
    &.message, &.finance {
      background: #FFFFFF;
      box-shadow: 0px 2px 20px 0px rgba(52,55,61,0.07);
    }
    &.online {
      background-image: linear-gradient(180deg, #259FE8 0%, #1066CC 100%);
      box-shadow: 0px 2px 10px 0px rgba(35,153,229,0.15);
    }
  }
}
</style>
